import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, Search, X } from "lucide-react";
import "../styles/SearchableDropdown.css";

const SearchableDropdown = ({
  options,
  value,
  onChange,
  placeholder = "בחר...",
  searchPlaceholder = "חפש...",
  icon: Icon,
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const filteredOptions = options.filter((option) =>
    option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
    setSearchTerm("");
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange("");
    setSearchTerm("");
  };

  const displayValue = value || placeholder;

  return (
    <div className={`searchable-dropdown ${className}`} ref={dropdownRef}>
      <div
        className={`dropdown-trigger ${isOpen ? "open" : ""} ${value ? "has-value" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {Icon && <Icon size={18} className="dropdown-icon" />}
        <span className="dropdown-value">{displayValue}</span>
        <div className="dropdown-actions">
          {value && (
            <button className="clear-btn" onClick={handleClear}>
              <X size={14} />
            </button>
          )}
          <ChevronDown size={18} className={`chevron ${isOpen ? "rotated" : ""}`} />
        </div>
      </div>

      {isOpen && (
        <div className="dropdown-menu">
          <div className="dropdown-search">
            <Search size={16} />
            <input
              ref={inputRef}
              type="text"
              placeholder={searchPlaceholder}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <div className="dropdown-options">
            <div
              className={`dropdown-option ${!value ? "selected" : ""}`}
              onClick={() => handleSelect("")}
            >
              {placeholder}
            </div>
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <div
                  key={option}
                  className={`dropdown-option ${value === option ? "selected" : ""}`}
                  onClick={() => handleSelect(option)}
                >
                  {option}
                </div>
              ))
            ) : (
              <div className="dropdown-no-results">לא נמצאו תוצאות</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;
